import * as angular from 'angular';
import JourneyView from './JourneyView.html';
import { journeyMfeScriptSource } from 'app.constants';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { JourneyController } from './JourneyController';
import { JourneyConstants } from './JourneyConstants';
import { JourneyFeatures } from './JourneyFeatures';
import { applicationListStateName } from 'modules/application/list';
const fetchJourneyPermission = ['$state', '$stateParams', 'InitializeUserService', 'AccountService2', async function ($state, $stateParams, InitializeUserService, AccountService2) {
        await AccountService2.waitForInitialization();
        await InitializeUserService.initFeatureToggle();
        const hasAccess = await JourneyFeatures.isJourneyEnabled($stateParams.shortName);
        if (!hasAccess) {
            $state.go(applicationListStateName);
        }
    }];
const stateBase = {
    views: {
        'content@auth.application.detail': {
            template: JourneyView,
            controller: JourneyController,
            controllerAs: '$ctrl',
            resolve: {
                authorization: fetchJourneyPermission,
            },
        },
    },
    onEnter: () => {
        MicroFrontendService.addSource(journeyMfeScriptSource);
    },
};
export const journey = angular
    .module('journey', ['ui.router'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state(JourneyConstants.JOURNEY_STATE, {
            url: '/journey',
            ...stateBase,
        })
            .state(JourneyConstants.JOURNEY_FUNNEL_STATE, {
            url: '/funnel',
            ...stateBase,
        })
            .state(JourneyConstants.JOURNEY_ANALYSIS_STATE, {
            url: '/analysis',
            ...stateBase,
        })
            .state(JourneyConstants.JOURNEY_CAMPAIGN_STATE, {
            url: '/campaign',
            ...stateBase,
        })
            .state(JourneyConstants.JOURNEY_CAMPAIGNS_STATE, {
            url: '/campaigns',
            ...stateBase,
        });
    }]).name;
